





import { defineComponent } from '@nuxtjs/composition-api';
import BaseListItem from '@shared/components/@atoms/BaseListItem/BaseListItem.vue';
import Vue from 'vue';
Vue.component('BaseListItem', BaseListItem);
export default defineComponent({
  name: 'BaseList',
});
